import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './FabricSource.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';

const FabricSource = () => {
      const userId = JSON.parse(localStorage.getItem('user'))?.userId
      console.log(userId,"koko")
      const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
  const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
    const navigate = useNavigate();
    return (
        <div className="fabric-source" >
            <div className='fabric-source-content'>
                <h1 className='fabric-source-title'>One stop fabric sourcing <br /> for manufacturers</h1>
                <p className='fabric-source-description'>We revolutionized fabric sourcing by streamlining and enhancing <br />the fabric supply chain to ensure efficiency and reliability.</p>
                  {isCustomer && (
          <Button
            className="fabric-source-btn"
            onClick={() => navigate('/fabrics', { state: { page: 0 } })}
          >
            Fabric Library
            <FontAwesomeIcon className="btn_icon" icon={faCircleArrowRight} />
          </Button>
        )}
        {!userId  &&  <Button
            className="fabric-source-btn"
            onClick={() => navigate('/fabrics', { state: { page: 0 } })}
          >
            Fabric Library
            <FontAwesomeIcon className="btn_icon" icon={faCircleArrowRight} />
          </Button>}

        {isVendor && (
          <Button
            className="fabric-source-btn"
            onClick={() => navigate('/VendorProducts', { state: { page: 0 } })}
          >
            Vendor Library
            <FontAwesomeIcon className="btn_icon" icon={faCircleArrowRight} />
          </Button>
        )}

            </div>
        </div>
    );
};

export default FabricSource;

